var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBesttigung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 133.88 133.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #52ae35;\n        stroke-linecap: round;\n        stroke-width: 7.25px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #52ae32;\n        stroke-width: 6.13px;\n      }\n\n      .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 133.88,
    height: 133.88
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.81,66.94c0,35.28-28.6,63.87-63.87,63.87S3.07,102.21,3.07,66.94,31.66,3.06,66.94,3.06s63.87,28.6,63.87,63.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.78,72.21l20.19,23.21c.61.7,1.69.7,2.29,0l45.17-51.91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesttigung);
export default __webpack_public_path__ + "static/media/Bestätigung.1c486d594ed7b4b8a1e8f5053fefffff.svg";
export { ForwardRef as ReactComponent };